import React from 'react'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

export const ZoomImage = ({src, alt, width}) => (
  <Zoom>
    <img
      alt={alt}
      src={src}
      width={width}
      style={{borderRadius: '5px', userSelect: 'none'}}
    />
  </Zoom>
)